import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cbb99884"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "odds-sections"
};
const _hoisted_2 = {
  class: "sec-title"
};
const _hoisted_3 = {
  class: "table-wrap"
};
const _hoisted_4 = {
  class: "odds-table"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "time-col",
  rowspan: "2"
}, "时间", -1));
const _hoisted_6 = ["colspan"];
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "time-col"
}, "时间", -1));
const _hoisted_9 = {
  class: "time-col"
};
const _hoisted_10 = {
  class: "val"
};
const _hoisted_11 = {
  key: 0,
  class: "arrow up"
};
const _hoisted_12 = {
  key: 1,
  class: "arrow down"
};
export default {
  __name: 'OddsHistoryTable',
  props: {
    sections: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    const props = __props;

    /**
     * 单元格样式：涨红、跌绿、无变化默认
     */
    const cellClass = cell => {
      if (cell && cell.dir > 0) return 'up-cell';
      if (cell && cell.dir < 0) return 'down-cell';
      return '';
    };

    /**
     * 展平分组列（有 groups 时取各组 columns，否则用 columns）
     */
    const flatColumns = sec => sec.groups ? sec.groups.reduce((acc, g) => acc.concat(g.columns), []) : sec.columns || [];
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sections, (sec, si) => {
        return _openBlock(), _createElementBlock("div", {
          key: si,
          class: "odds-section"
        }, [_createElementVNode("div", _hoisted_2, _toDisplayString(sec.title), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("table", _hoisted_4, [_createElementVNode("thead", null, [sec.groups ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("tr", null, [_hoisted_5, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sec.groups, (g, gi) => {
          return _openBlock(), _createElementBlock("th", {
            key: 'g-' + gi,
            class: "group-head",
            colspan: g.columns.length
          }, _toDisplayString(g.label), 9, _hoisted_6);
        }), 128))]), _createElementVNode("tr", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flatColumns(sec), col => {
          return _openBlock(), _createElementBlock("th", {
            key: col.key
          }, _toDisplayString(col.label), 1);
        }), 128))])], 64)) : (_openBlock(), _createElementBlock("tr", _hoisted_7, [_hoisted_8, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sec.columns, col => {
          return _openBlock(), _createElementBlock("th", {
            key: col.key
          }, _toDisplayString(col.label), 1);
        }), 128))]))]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sec.rows, (row, ri) => {
          return _openBlock(), _createElementBlock("tr", {
            key: ri,
            class: _normalizeClass({
              'row-first': ri === 0,
              'row-last': ri === sec.rows.length - 1
            })
          }, [_createElementVNode("td", _hoisted_9, [row.tag ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["tag", row.tag === '初始' ? 'tag-init' : 'tag-last'])
          }, _toDisplayString(row.tag), 3)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(row.time), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flatColumns(sec), col => {
            return _openBlock(), _createElementBlock("td", {
              key: col.key,
              class: _normalizeClass(cellClass(row.cells[col.key]))
            }, [_createElementVNode("span", _hoisted_10, _toDisplayString(row.cells[col.key] ? row.cells[col.key].v : '-'), 1), row.cells[col.key] && row.cells[col.key].dir > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_11, "▲")) : row.cells[col.key] && row.cells[col.key].dir < 0 ? (_openBlock(), _createElementBlock("span", _hoisted_12, "▼")) : _createCommentVNode("", true)], 2);
          }), 128))], 2);
        }), 128))])])])]);
      }), 128))]);
    };
  }
};